/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as UnauthenticatedRouteImport } from './routes/_unauthenticated'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as UnauthenticatedRegisterRouteImport } from './routes/_unauthenticated/register'
import { Route as UnauthenticatedLogoutRouteImport } from './routes/_unauthenticated/logout'
import { Route as UnauthenticatedLoginRouteImport } from './routes/_unauthenticated/login'
import { Route as UnauthenticatedAcceptInvitationRouteImport } from './routes/_unauthenticated/accept-invitation'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as AuthenticatedUpgradeRouteImport } from './routes/_authenticated/upgrade'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedKbRouteImport } from './routes/_authenticated/kb'
import { Route as AuthenticatedIntegrationsRouteImport } from './routes/_authenticated/integrations'
import { Route as AuthenticatedDomainsRouteImport } from './routes/_authenticated/domains'
import { Route as AuthenticatedBrandThemesRouteImport } from './routes/_authenticated/brand-themes'
import { Route as AuthenticatedBillingRouteImport } from './routes/_authenticated/billing'
import { Route as AuthenticatedKbUuidRouteImport } from './routes/_authenticated/kb_.$uuid'
import { Route as AuthenticatedKbUuidQueryUuidRouteImport } from './routes/_authenticated/kb_.$uuid_.$queryUuid'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedRoute = UnauthenticatedRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const UnauthenticatedRegisterRoute = UnauthenticatedRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const UnauthenticatedLogoutRoute = UnauthenticatedLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const UnauthenticatedLoginRoute = UnauthenticatedLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const UnauthenticatedAcceptInvitationRoute =
  UnauthenticatedAcceptInvitationRouteImport.update({
    id: '/accept-invitation',
    path: '/accept-invitation',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUpgradeRoute = AuthenticatedUpgradeRouteImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedKbRoute = AuthenticatedKbRouteImport.update({
  id: '/kb',
  path: '/kb',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedIntegrationsRoute =
  AuthenticatedIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDomainsRoute = AuthenticatedDomainsRouteImport.update({
  id: '/domains',
  path: '/domains',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBrandThemesRoute =
  AuthenticatedBrandThemesRouteImport.update({
    id: '/brand-themes',
    path: '/brand-themes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBillingRoute = AuthenticatedBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedKbUuidRoute = AuthenticatedKbUuidRouteImport.update({
  id: '/kb_/$uuid',
  path: '/kb/$uuid',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedKbUuidQueryUuidRoute =
  AuthenticatedKbUuidQueryUuidRouteImport.update({
    id: '/kb_/$uuid_/$queryUuid',
    path: '/kb/$uuid/$queryUuid',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/verify-email': typeof VerifyEmailRoute
  '/billing': typeof AuthenticatedBillingRoute
  '/brand-themes': typeof AuthenticatedBrandThemesRoute
  '/domains': typeof AuthenticatedDomainsRoute
  '/integrations': typeof AuthenticatedIntegrationsRoute
  '/kb': typeof AuthenticatedKbRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/upgrade': typeof AuthenticatedUpgradeRoute
  '/users': typeof AuthenticatedUsersRoute
  '/accept-invitation': typeof UnauthenticatedAcceptInvitationRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/logout': typeof UnauthenticatedLogoutRoute
  '/register': typeof UnauthenticatedRegisterRoute
  '/': typeof AuthenticatedIndexRoute
  '/kb/$uuid': typeof AuthenticatedKbUuidRoute
  '/kb/$uuid/$queryUuid': typeof AuthenticatedKbUuidQueryUuidRoute
}
export interface FileRoutesByTo {
  '/verify-email': typeof VerifyEmailRoute
  '/billing': typeof AuthenticatedBillingRoute
  '/brand-themes': typeof AuthenticatedBrandThemesRoute
  '/domains': typeof AuthenticatedDomainsRoute
  '/integrations': typeof AuthenticatedIntegrationsRoute
  '/kb': typeof AuthenticatedKbRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/upgrade': typeof AuthenticatedUpgradeRoute
  '/users': typeof AuthenticatedUsersRoute
  '/accept-invitation': typeof UnauthenticatedAcceptInvitationRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/logout': typeof UnauthenticatedLogoutRoute
  '/register': typeof UnauthenticatedRegisterRoute
  '/': typeof AuthenticatedIndexRoute
  '/kb/$uuid': typeof AuthenticatedKbUuidRoute
  '/kb/$uuid/$queryUuid': typeof AuthenticatedKbUuidQueryUuidRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/_authenticated/billing': typeof AuthenticatedBillingRoute
  '/_authenticated/brand-themes': typeof AuthenticatedBrandThemesRoute
  '/_authenticated/domains': typeof AuthenticatedDomainsRoute
  '/_authenticated/integrations': typeof AuthenticatedIntegrationsRoute
  '/_authenticated/kb': typeof AuthenticatedKbRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/upgrade': typeof AuthenticatedUpgradeRoute
  '/_authenticated/users': typeof AuthenticatedUsersRoute
  '/_unauthenticated/accept-invitation': typeof UnauthenticatedAcceptInvitationRoute
  '/_unauthenticated/login': typeof UnauthenticatedLoginRoute
  '/_unauthenticated/logout': typeof UnauthenticatedLogoutRoute
  '/_unauthenticated/register': typeof UnauthenticatedRegisterRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/kb_/$uuid': typeof AuthenticatedKbUuidRoute
  '/_authenticated/kb_/$uuid_/$queryUuid': typeof AuthenticatedKbUuidQueryUuidRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/verify-email'
    | '/billing'
    | '/brand-themes'
    | '/domains'
    | '/integrations'
    | '/kb'
    | '/settings'
    | '/upgrade'
    | '/users'
    | '/accept-invitation'
    | '/login'
    | '/logout'
    | '/register'
    | '/'
    | '/kb/$uuid'
    | '/kb/$uuid/$queryUuid'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/verify-email'
    | '/billing'
    | '/brand-themes'
    | '/domains'
    | '/integrations'
    | '/kb'
    | '/settings'
    | '/upgrade'
    | '/users'
    | '/accept-invitation'
    | '/login'
    | '/logout'
    | '/register'
    | '/'
    | '/kb/$uuid'
    | '/kb/$uuid/$queryUuid'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_unauthenticated'
    | '/verify-email'
    | '/_authenticated/billing'
    | '/_authenticated/brand-themes'
    | '/_authenticated/domains'
    | '/_authenticated/integrations'
    | '/_authenticated/kb'
    | '/_authenticated/settings'
    | '/_authenticated/upgrade'
    | '/_authenticated/users'
    | '/_unauthenticated/accept-invitation'
    | '/_unauthenticated/login'
    | '/_unauthenticated/logout'
    | '/_unauthenticated/register'
    | '/_authenticated/'
    | '/_authenticated/kb_/$uuid'
    | '/_authenticated/kb_/$uuid_/$queryUuid'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  UnauthenticatedRoute: typeof UnauthenticatedRouteWithChildren
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_unauthenticated/register': {
      id: '/_unauthenticated/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof UnauthenticatedRegisterRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/logout': {
      id: '/_unauthenticated/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof UnauthenticatedLogoutRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/login': {
      id: '/_unauthenticated/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthenticatedLoginRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/accept-invitation': {
      id: '/_unauthenticated/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof UnauthenticatedAcceptInvitationRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/upgrade': {
      id: '/_authenticated/upgrade'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof AuthenticatedUpgradeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/kb': {
      id: '/_authenticated/kb'
      path: '/kb'
      fullPath: '/kb'
      preLoaderRoute: typeof AuthenticatedKbRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/integrations': {
      id: '/_authenticated/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AuthenticatedIntegrationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/domains': {
      id: '/_authenticated/domains'
      path: '/domains'
      fullPath: '/domains'
      preLoaderRoute: typeof AuthenticatedDomainsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/brand-themes': {
      id: '/_authenticated/brand-themes'
      path: '/brand-themes'
      fullPath: '/brand-themes'
      preLoaderRoute: typeof AuthenticatedBrandThemesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/billing': {
      id: '/_authenticated/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthenticatedBillingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/kb_/$uuid': {
      id: '/_authenticated/kb_/$uuid'
      path: '/kb/$uuid'
      fullPath: '/kb/$uuid'
      preLoaderRoute: typeof AuthenticatedKbUuidRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/kb_/$uuid_/$queryUuid': {
      id: '/_authenticated/kb_/$uuid_/$queryUuid'
      path: '/kb/$uuid/$queryUuid'
      fullPath: '/kb/$uuid/$queryUuid'
      preLoaderRoute: typeof AuthenticatedKbUuidQueryUuidRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedBillingRoute: typeof AuthenticatedBillingRoute
  AuthenticatedBrandThemesRoute: typeof AuthenticatedBrandThemesRoute
  AuthenticatedDomainsRoute: typeof AuthenticatedDomainsRoute
  AuthenticatedIntegrationsRoute: typeof AuthenticatedIntegrationsRoute
  AuthenticatedKbRoute: typeof AuthenticatedKbRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedUpgradeRoute: typeof AuthenticatedUpgradeRoute
  AuthenticatedUsersRoute: typeof AuthenticatedUsersRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedKbUuidRoute: typeof AuthenticatedKbUuidRoute
  AuthenticatedKbUuidQueryUuidRoute: typeof AuthenticatedKbUuidQueryUuidRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedBillingRoute: AuthenticatedBillingRoute,
  AuthenticatedBrandThemesRoute: AuthenticatedBrandThemesRoute,
  AuthenticatedDomainsRoute: AuthenticatedDomainsRoute,
  AuthenticatedIntegrationsRoute: AuthenticatedIntegrationsRoute,
  AuthenticatedKbRoute: AuthenticatedKbRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedUpgradeRoute: AuthenticatedUpgradeRoute,
  AuthenticatedUsersRoute: AuthenticatedUsersRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedKbUuidRoute: AuthenticatedKbUuidRoute,
  AuthenticatedKbUuidQueryUuidRoute: AuthenticatedKbUuidQueryUuidRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface UnauthenticatedRouteChildren {
  UnauthenticatedAcceptInvitationRoute: typeof UnauthenticatedAcceptInvitationRoute
  UnauthenticatedLoginRoute: typeof UnauthenticatedLoginRoute
  UnauthenticatedLogoutRoute: typeof UnauthenticatedLogoutRoute
  UnauthenticatedRegisterRoute: typeof UnauthenticatedRegisterRoute
}

const UnauthenticatedRouteChildren: UnauthenticatedRouteChildren = {
  UnauthenticatedAcceptInvitationRoute: UnauthenticatedAcceptInvitationRoute,
  UnauthenticatedLoginRoute: UnauthenticatedLoginRoute,
  UnauthenticatedLogoutRoute: UnauthenticatedLogoutRoute,
  UnauthenticatedRegisterRoute: UnauthenticatedRegisterRoute,
}

const UnauthenticatedRouteWithChildren = UnauthenticatedRoute._addFileChildren(
  UnauthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  UnauthenticatedRoute: UnauthenticatedRouteWithChildren,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
